export default {
  title: 'Georgia, Mexico, Indonesia',
  presenter: 'ge_mx_id',
  text: `
# Embassy of Georgia - Bratislava
## George Robakidze - Depute Head of Georgian Embassy

# Embassy of Mexico - Vienna
## Rodrigo Báez - Second Secretary Multilateral Affairs and Economic Promotion

# Embassy of Indonesia
## Addy Perdana Soemantry - Head of ITPC center in Budapest

  `,
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/presentations/ge_mx_id.js